import Button from '@mui/material/Button'

export default function Page() {
  return <div>
    <div>
      <Button variant="text">Text</Button>
      <Button variant="contained">Contained</Button>
      <Button variant="outlined">Outlined</Button>
    </div>
    <div>
      <Button disabled variant="text">disabled</Button>
      <Button disabled variant="contained">disabled</Button>
      <Button disabled variant="outlined">disabled</Button>
    </div>
    {['success', 'error', 'warning', 'primary', 'secondary'].map(color =>
      <div>
        <Button  variant="text" color={color}>{`color="${color}"`}</Button>
        <Button  variant="contained" color={color}>{`color="${color}"`}</Button>
        <Button  variant="outlined" color={color}>{`color="${color}"`}</Button>
      </div>
    )}
  </div>
}
